
















import { Component, mixins } from '@niknevis/vue-modules'
import { FilterComponentsMixin } from '@/modules/common/filter/mixins/filterComponentsMixin'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'

@Component({
  components: { BaseInput }
})
export default class TextBox extends mixins(FilterComponentsMixin) {
}
